module.exports = __webpack_public_path__ + "static/media/background.6c8a1e9b.png";